import { ActiveTablesTypes, tableTypesEnum } from 'shared/models/LastWins'

export const replaceTableTypes = {
  [ActiveTablesTypes.standard]: tableTypesEnum.lastBets,
  [ActiveTablesTypes.luckyBets]: tableTypesEnum.luckyBets,
  [ActiveTablesTypes.highRollers]: tableTypesEnum.highRollers,
}

export function getReplacedTableType(tableType: ActiveTablesTypes) {
  return replaceTableTypes[tableType]
}

export const activeTableTypesSortList = [
  ActiveTablesTypes.standard,
  ActiveTablesTypes.highRollers,
  ActiveTablesTypes.luckyBets,
]
